import React from 'react';
import { company } from '../mock';

const phoneDigits = company.phone.replace(/\s|\+/g, '');
const message = encodeURIComponent('Bonjour, je souhaite obtenir un devis pour un transport.');
const waLink = `https://wa.me/${phoneDigits}?text=${message}`;

const WhatsAppButton = () => {
  return (
    <a
      href={waLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contacter Ha Transport sur WhatsApp"
      className="ha-wa-btn fixed bottom-5 left-5 z-50 group flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5a] text-white pl-3 pr-5 py-3 rounded-full shadow-2xl transition-transform hover:scale-105"
    >
      <span className="ha-wa-pulse w-11 h-11 rounded-full bg-white/15 flex items-center justify-center">
        <svg viewBox="0 0 24 24" className="w-7 h-7 fill-white" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M19.11 4.91A10.04 10.04 0 0 0 12.04 2C6.55 2 2.08 6.47 2.08 11.96c0 1.76.46 3.46 1.34 4.97L2 22l5.21-1.36a9.95 9.95 0 0 0 4.83 1.23h.01c5.49 0 9.96-4.47 9.96-9.96 0-2.66-1.04-5.16-2.9-7.0Zm-7.07 15.32h-.01a8.27 8.27 0 0 1-4.21-1.15l-.3-.18-3.09.81.83-3.01-.2-.31a8.28 8.28 0 0 1-1.27-4.43c0-4.57 3.72-8.29 8.29-8.29 2.21 0 4.29.86 5.86 2.43a8.23 8.23 0 0 1 2.43 5.86c0 4.57-3.72 8.27-8.33 8.27Zm4.55-6.2c-.25-.12-1.47-.72-1.7-.81-.23-.08-.4-.12-.56.12-.17.25-.65.81-.79.97-.15.17-.29.18-.54.06-.25-.12-1.05-.39-2-1.23a7.5 7.5 0 0 1-1.39-1.72c-.14-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.77-1.84-.2-.49-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.57.12.17 1.74 2.65 4.21 3.71.59.25 1.05.4 1.41.51.59.19 1.13.16 1.55.1.47-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.14-1.18-.06-.11-.23-.18-.48-.3Z"/>
        </svg>
      </span>
      <span className="hidden md:flex flex-col leading-tight">
        <span className="text-[10px] tracking-[0.25em] uppercase text-white/85">WhatsApp</span>
        <span className="text-sm font-semibold tracking-wide">+33 7 51 28 41 24</span>
      </span>
    </a>
  );
};

export default WhatsAppButton;
